module.exports = __webpack_public_path__ + "img/1525419192.8f18c0a8.jpg";